<script setup>
import { ref, computed } from 'vue'
import TableList from '../others/TableList.vue'
import Commons from '@/shared/utils/commons'
import SlideDetailView from '../others/SlideDetailView.vue'
import SponsorshipDetails from '../sponsorships/SponsorshipDetails.vue'

const detailData = ref(null)

const cols = computed(() => [
  {
    name: 'Restaurant',
    id: 'storeName',
    value(el) {
      return [
        el.storeName || 'Plusieurs restaurants'
      ]
    }
  },
  {
    name: 'Montant',
    id: 'amount',
    value(el) {
      const val = Commons.formatNumber(el.amount, { suffix: ' F' })
      return `<span class="font-black text-primary-600 bg-primary-50 px-2 py-1 rounded-lg text-sm">${val}</span>`
    }
  },
  {
    name: 'Début',
    id: 'startDate',
    value(el) {
      return el.startDate ? Commons.time(el.startDate, 'DD MMM YYYY') : '??'
    }
  },
  {
    name: 'Fin',
    id: 'endDate',
    value(el) {
      return el.endDate ? Commons.time(el.endDate, 'DD MMM YYYY') : '??'
    }
  },
  {
    name: 'Statut',
    id: 'status',
    filter: {
      key: 'status',
      default: '',
      options: [
        { name: 'Tout', value: '' },
        { name: 'En attente', value: 'pending' },
        { name: 'Approuvé', value: 'approved' },
        { name: 'Actif', value: 'active' },
        { name: 'Rejeté', value: 'rejected' },
        { name: 'Expiré', value: 'expired' },
      ]
    },
    value(el) {
      const status = el.status
      let colorClass = 'text-gray-400 bg-gray-50 border-gray-200'
      let label = status || 'Inconnu'

      if (status === 'active') {
        colorClass = 'text-success-600 bg-success-50 border-success-200'
        label = 'Actif'
      } else if (status === 'pending') {
        colorClass = 'text-orange-600 bg-orange-50 border-orange-200'
        label = 'En attente'
      } else if (status === 'approved') {
        colorClass = 'text-blue-600 bg-blue-50 border-blue-200'
        label = 'Approuvé'
      } else if (status === 'rejected') {
        colorClass = 'text-red-600 bg-red-50 border-red-200'
        label = 'Rejeté'
      } else if (status === 'expired') {
        colorClass = 'text-gray-500 bg-gray-100 border-gray-300'
        label = 'Expiré'
      }

      return `<span class="${colorClass} text-[10px] font-bold uppercase tracking-widest px-2 py-1 rounded-full border opacity-80">${label}</span>`
    }
  },
  {
    name: '',
    id: 'action',
    icon: () => '/images/icons/dots.png',
    options() {
      return [
        { name: 'Voir plus', value: 'details' }
      ]
    },
    onClick(opt, el) {
      if (opt.value === 'details') {
        detailData.value = el
      }
    },
    value() {},
  },
])
</script>

<template>
  <div class="p-5 h-full overflow-auto bg-gray-50">
    <div class="mb-8 flex justify-between items-end">
      <div>
        <h1 class="text-3xl font-black text-gray-900 mb-1 tracking-tight">Sponsorisations</h1>
        <p class="text-gray-500 text-sm">Gérez les mises en avant et positions sponsorisées des restaurants</p>
      </div>
      <div class="flex gap-2">
      </div>
    </div>
    
    <div class="bg-white rounded-3xl shadow-sm border border-gray-200 overflow-hidden">
      <TableList
        title="Liste des Sponsorisations"
        dataKey="sponsorships"
        hasSearch
        :cols="cols"
        refreshOnEvents="SPONSORSHIP_UPDATED"
      ></TableList>
    </div>

    <!-- Sponsorship Details -->
    <SlideDetailView :isVisible="!!detailData" @hide="detailData = null">
      <SponsorshipDetails
        v-if="detailData"
        :sponsorshipData="detailData"
        @delete="detailData = null"
      ></SponsorshipDetails>
    </SlideDetailView>
  </div>
</template>
